import React from 'react';
import { Phone } from 'lucide-react';

const OTPVerificationModal = ({
  mobile,
  otp,
  handleOtpChange,
  handleOtpKeyDown,
  otpMethod,
  timer,
  canResend,
  resendOTP,
  verifyOTP,
  setAuthStep,
  userProfile,
  setUserProfile
}) => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center z-50 p-2 sm:p-4 overflow-y-auto">
      <div className="bg-white w-full max-w-md rounded-2xl sm:rounded-3xl p-6 sm:p-8 shadow-2xl my-4 sm:my-8">
        <button
          onClick={() => setAuthStep('phone')}
          className="text-gray-600 mb-3 sm:mb-4 text-sm sm:text-base hover:text-gray-800"
        >
          ← Back
        </button>

        <div className="text-center mb-6 sm:mb-8">
          <div className="w-16 h-16 sm:w-20 sm:h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
            <Phone size={28} className="sm:w-8 sm:h-8 text-green-600" />
          </div>
          <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">Verify OTP</h2>
          <p className="text-sm sm:text-base text-gray-600">
            Code sent via {otpMethod === 'sms' ? 'SMS' : 'WhatsApp'} to
          </p>
          <p className="font-semibold text-gray-800 text-sm sm:text-base">+91 {mobile}</p>
        </div>

        <div className="mb-4 sm:mb-6">
          <div className="flex gap-2 sm:gap-3 justify-center mb-3 sm:mb-4">
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-${index}`}
                type="text"
                maxLength="1"
                value={digit}
                onChange={(e) => handleOtpChange(index, e.target.value)}
                onKeyDown={(e) => handleOtpKeyDown(index, e)}
                className="w-10 h-12 sm:w-12 sm:h-14 text-center text-xl sm:text-2xl font-bold border-2 border-gray-300 rounded-xl focus:border-blue-500 outline-none transition-all"
              />
            ))}
          </div>

          <div className="text-center">
            {canResend ? (
              <button
                onClick={resendOTP}
                className="text-blue-600 font-semibold hover:underline text-sm sm:text-base"
              >
                Resend OTP
              </button>
            ) : (
              <p className="text-gray-500 text-sm sm:text-base">
                Resend OTP in <span className="font-semibold text-blue-600">{timer}s</span>
              </p>
            )}
          </div>
        </div>

        <button
          onClick={verifyOTP}
          disabled={otp.join('').length !== 6}
          className="w-full bg-blue-600 text-white py-3 sm:py-4 rounded-xl font-semibold hover:bg-blue-700 transition-all disabled:bg-gray-300 disabled:cursor-not-allowed text-sm sm:text-base"
        >
          Verify & Continue
        </button>

        <p className="text-xs text-gray-500 text-center mt-3 sm:mt-4">
          Demo OTP: 123456
        </p>
      </div>
    </div>
  );
};

export default OTPVerificationModal;